import { Component, OnInit } from "@angular/core";
import { INDRABFMDataStorageService } from "@ibe.services/bfm-data-storage.indra.service";
import { SidebarService } from "@ibe/services/ui";

@Component({
  selector: "app-partner-hotel-info",
  templateUrl: "./partner-hotel-info.indra.component.html",
  styleUrls: ["./partner-hotel-info.component.scss"],
})
export class INDRAPartnerHotelInfoComponent implements OnInit {
  city: string;

  constructor(
    private sidebarService: SidebarService,
    private bfmStorage: INDRABFMDataStorageService
  ) {}

  ngOnInit() {
    this.city = this.bfmStorage.INDRA_getStopoverDestination();
  }

  INDRA_handleClose() {
    this.sidebarService.closeSidebar();
  }
}
